export default __webpack_public_path__ + "static/logo-bd62a628b52a8b5979f1ad659fc1c53f.png";